import MediaControls from './MediaControls';
import { PLAYER_STATES } from './constants/playerStates';

export { PLAYER_STATES };

export default MediaControls;
